import { connect } from 'react-redux';
import { isLoaded } from 'react-redux-firebase';
import { Link } from 'react-router-dom';
import { Divider, Grid, Header, Image, Item, Segment } from 'semantic-ui-react';
import { authorization } from '../../../app/common/util/authorization';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import WikiNav from '../WikiNav';
import { WikiSearchProvider } from '../WikiSearchContext';
import EmployeeHandbook from './EmployeeHandbook';
import ParentGuardianHandbook from './ParentGuardianHandbook';

const sessionImageStyle = {
  filter: 'brightness(100%)',
};

const sessionImageTextStyle = {
  position: 'absolute',
  bottom: '5%',
  left: '1%',
  width: '100%',
  height: 'auto',
  color: 'white',
};

const mapState = (state) => ({
  profile: state.firebase.profile,
});

const Handbooks = ({ hasRole, profile }) => {
  hasRole = (role) => {
    return authorization.hasRole(role, profile);
  };

  if (!isLoaded(profile)) return <LoadingComponent />;

  return (
    <WikiSearchProvider>
      <Grid id="detailed-segment">
        <Grid.Column width={16}>
          {hasRole(['pc', 'admin', 'pm', 'auditor']) && (
            <Segment.Group>
              <Segment
                basic
                attached="top"
                style={{ padding: '0' }}
                id="segment"
              >
                <Image
                  src={`/assets/categoryImages/PinkHeader.svg`}
                  id="header-image"
                  fluid
                  style={sessionImageStyle}
                />
                <Segment basic style={sessionImageTextStyle}>
                  <Item.Group>
                    <Item>
                      <Item.Content>
                        <Header size="huge" id="wiki-header">
                          Handbooks
                        </Header>
                      </Item.Content>
                    </Item>
                  </Item.Group>
                </Segment>
              </Segment>

              <Segment id="segment">
                <WikiNav />
                <Grid verticalAlign="middle">
                  <Grid.Column width={16} id="dg">
                    <br />
                    <Header as={Link} id="pink" to="/bhpGuide">
                      Employee Handbook
                    </Header>
                    <EmployeeHandbook />
                    <Header as="h3" id="pink">
                      Parent/Guardian Handbook
                    </Header>
                    <ParentGuardianHandbook />
                  </Grid.Column>
                </Grid>
              </Segment>
            </Segment.Group>
          )}

          {hasRole(['bhp']) && (
            <Segment.Group>
              <Segment
                basic
                attached="top"
                style={{ padding: '0' }}
                id="segment"
              >
                <Image
                  src={`/assets/categoryImages/PinkHeader.svg`}
                  id="header-image"
                  fluid
                  style={sessionImageStyle}
                />
                <Segment basic style={sessionImageTextStyle}>
                  <Item.Group>
                    <Item>
                      <Item.Content>
                        <Header size="huge" id="wiki-header">
                          Employee Handbook
                        </Header>
                      </Item.Content>
                    </Item>
                  </Item.Group>
                </Segment>
              </Segment>

              <Segment id="segment">
                <WikiNav />
                <Divider />
                <Grid verticalAlign="middle">
                  <Grid.Column width={16} id="dg">
                    <Header as="h3" id="pink">
                      Employee Handbook
                    </Header>
                    <EmployeeHandbook />
                  </Grid.Column>
                </Grid>
              </Segment>
            </Segment.Group>
          )}

          {hasRole(['client']) && (
            <Segment.Group>
              <Segment
                basic
                attached="top"
                style={{ padding: '0' }}
                id="segment"
              >
                <Image
                  src={`/assets/categoryImages/PinkHeader.svg`}
                  id="header-image"
                  fluid
                  style={sessionImageStyle}
                />
                <Segment basic style={sessionImageTextStyle}>
                  <Item.Group>
                    <Item>
                      <Item.Content>
                        <Header size="huge" id="wiki-header">
                          Parent/Guardian Handbook
                        </Header>
                      </Item.Content>
                    </Item>
                  </Item.Group>
                </Segment>
              </Segment>

              <Segment id="segment">
                <WikiNav />
                <Divider />
                <Grid verticalAlign="middle">
                  <Grid.Column width={16} id="dg">
                    <Header as="h3" id="pink">
                      Parent/Guardian Handbook
                    </Header>
                    <ParentGuardianHandbook />
                  </Grid.Column>
                </Grid>
              </Segment>
            </Segment.Group>
          )}
        </Grid.Column>
      </Grid>
    </WikiSearchProvider>
  );
};

export default connect(mapState)(Handbooks);
